export interface IToast {
  type?: MessageType,
  detail: string,
  summary?: string,
  position?: PositionType,
  duration?: number,
  sticky?: boolean,
}

export enum Position {
  topRight = 'tr',
  topLeft = 'tl',
  topCenter = 'tc',
  bottomRight = 'br',
  bottomLeft = 'bl',
  botomCenter = 'bc'
}

export enum Message {
  error = 'error',
  success = 'success',
  warning = 'warning',
  info = 'info'
}

export type PositionType = keyof typeof Position;
export type MessageType = keyof typeof Message;
